import React from "react";
import "./Certifications.css";
import Reveal from "../../components/reveal/Reveal";
import { certifications } from "../../portfolio";
import CertificationCard from "../../components/certificationCard/CertificationCard";

export default function Certifications() {
  return (
    <section className="main certs-section" id="certs">
      <Reveal>
        <div className="section-head">
          <span className="section-kicker">Certifications</span>
          <h2 className="section-title sm">Courses &amp; certificates</h2>
        </div>
      </Reveal>
      <div className="certs-body-div">
        {certifications.certifications.map((cert, i) => (
          <Reveal key={cert.title} delay={(i % 3) * 120} className="reveal-fill">
            <CertificationCard certificate={cert} />
          </Reveal>
        ))}
      </div>
    </section>
  );
}
